
import Select, {components} from "react-select";
import React from "react";
import PropTypes from 'prop-types';
import { DropdownIndicator } from "../../../../lib/helpers";
import { Icon } from '../Icon/Icon';
import { Chip, Chips } from "../Chips/Chips";

export const MultiSelectDropdown = ({ id, isMulti, readOnly, error, onChange,  value, label,  active, options, menuIsOpen }) => {

    const { ValueContainer, Placeholder } = components;

    let selected_value = null;

    let option_array = null;

    if (isMulti) {
        selected_value = [];
        value.forEach(function (item) {
            selected_value.push({ "label": item, "value": item });
        })


        // check option array
        option_array = [];
        //console.log(options)
        options.forEach(function (items) {

            const checkValue = value.findIndex(item => item === items.value);
            if(checkValue !== -1){
                option_array.push({ ...items,color:'#cccccc', isDisabled: true});
            }else{
                option_array.push({ ...items,color:'#cccccc', isDisabled: false});
            }

        })

        //console.log(option_array)

    } else {
        if (value) {
            selected_value = {
                label: value,
                value: value
            };
        }

        option_array = [];
        options.forEach(function (items) {

            option_array.push({ ...items,color:'', isDisabled: false})

        })
    }
    const customStyles = {
        placeholder: (base, state) => ({
            ...base,
            display: 
              state.isFocused || state.isSelected || state.selectProps.inputValue
              ? 'none'
              : 'block',
          }),
      }

        const NewValueContainer = (props) => {
          const shouldFloatLabel = props.selectProps.menuIsOpen || props.hasValue;
      
          return (
            <components.ValueContainer {...props}>
              {shouldFloatLabel && <p>{label}</p>}
              {props.children}
            </components.ValueContainer>
          );
        };

        const CustomValueContainer = ({ children, ...props }) => {
            return (
                <ValueContainer {...props}>
                    <Placeholder {...props} isFocused={props.isFocused}>
                        {props.selectProps.placeholder}
                    </Placeholder>
                    {React.Children.map(children, child => {
                           // console.log(child)
                            return child && child.type !== Placeholder ? child : null
                        }
                    )}
                </ValueContainer>
            );
        }

    return (
        <div className={` dropdown-container form-group input-field mb-0 ${readOnly?"read-only-dropdown":""} ${error?"field-error":""} ${((value != '' && value != null) || active == true) ? 'focused' : ''} ${(active == true) ? 'active' : ''}`} id={id} >
            <div className={`input-position-relative  dropdown-field country-dropdown multiselect-dropdown`}>
            {readOnly?
                <Select
                    isMulti={true}
                    isClearable={false}
                    isSearchable={false}
                    isDisabled={false}
                    hideSelectedOptions={false}
                    //closeMenuOnSelect={false}
                    name="countries"
                    options={option_array}
                    onChange={onChange}
                    placeholder={label}
                    value={selected_value}
                    styles={customStyles}
                    menuIsOpen={false}
                    classNamePrefix="userq-select"
                    components={{ ValueContainer: CustomValueContainer,DropdownIndicator }}
                    // components={{ ValueContainer: NewValueContainer,DropdownIndicator }}
                />
                :
                <Select
                    isMulti={true}
                    isClearable={false}
                    isSearchable={false}
                    isDisabled={false}
                    hideSelectedOptions={false}
                    //closeMenuOnSelect={false}
                    name="countries"
                    options={option_array}
                    onChange={onChange}
                    placeholder={label}
                    value={selected_value}
                    // components={{ DropdownIndicator }}
                    components={{
                        ValueContainer: CustomValueContainer,DropdownIndicator
                    }}
                    styles={{
                        placeholder: (provided, state) => ({
                            ...provided,
                            display: state.selectProps.inputValue ? "none" : "block",
                        })
                    }}
                    classNamePrefix="userq-select"
                    // components={{ ValueContainer: NewValueContainer,DropdownIndicator }}
                />
            }
                {/* <span class="input-icon multiselect-search-icon"><Icon value="search" size="medium"/></span> */}
                {/* <label className="control-label body-text body-text-2" htmlFor={id}>

                    {label}
                </label> */}
               
                
            </div>
            <div className="dropdown-chips chips-without-flag">{value.map((data,i)=>(<Chip title={data} type="icon-right" 
                onRemove={() => {
                    let new_selected = [];

                    selected_value.forEach(function (item) {
                        if (item.value != data) {
                            new_selected.push(item);
                        }
                    })
                    if (onChange) {
                        onChange(new_selected)
                    }
                   // console.log(new_selected)
                }}

            />))}</div>
            {error != null && (
                <span className="caption">
                    {error}
                </span>
            )}
        </div>
    );
}

MultiSelectDropdown.propTypes = {
    id: PropTypes.string,
    onChange: PropTypes.func,
    label: PropTypes.string,
    inactive: PropTypes.bool,
    focussed: PropTypes.bool,
    open: PropTypes.bool,
    isMulti: PropTypes.bool,
    menuIsOpen: PropTypes.bool,
    type: PropTypes.string,

};
MultiSelectDropdown.defaultProps = {
    onChange: undefined,
    inactive: false,
    focussed: false,
    open: false,
    type: "country",
    isMulti:true,
    menuIsOpen:false,
};
